<div class="modal-header">
    <h4>{{ data.title }}</h4>
    <button type="button" class="close-btn" (click)="onCancel()">&times;</button>
</div>
<div class="modal-body">
    <div class="modal-body-center">
        <p>{{ data.message }}</p>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="regular-btn action-btn {{ confirmButtonClass }}" (click)="onConfirm()">{{ confirmText }}</button>
    <button type="button" class="regular-btn action-btn clear-btn" (click)="onCancel()">{{ cancelText }}</button>
</div>
